import React from 'react';
import { CardText } from 'reactstrap';

const wordClassName = word => word && word.tag === 'MWE' ? 'font-weight-bold' : '';

const populateSentence = sent => sent.map((word, index) =>
  <span key={index} className={wordClassName(word)}>{word.word} </span>);

export const TextWithMwe = (data) => {
  return data.data.map((sent, index) => {
    return (
      <CardText key={index}>
        {populateSentence(sent)}
      </CardText>
    );
  })
};
